import { useCallback } from "react";
import { SearchDialogStatesType } from "../states/dialogs";

export const useSearchRequestInputDialogHandlers = (
  dialogStates: SearchDialogStatesType
) => {
  const onClose = useCallback(() => {
    dialogStates.setRequestInputDialogMode(undefined);
    dialogStates.setRequestInputDialogInitialLatitude(undefined);
    dialogStates.setRequestInputDialogInitialLongitude(undefined);
  }, [dialogStates]);

  const onOkButtonClick = useCallback(() => {}, []);

  return {
    onClose,
    onOkButtonClick
  } as const;
};

export type SearchRequestInputDialogHandlersType = ReturnType<
  typeof useSearchRequestInputDialogHandlers
>;
